import React from 'react'
import styled from 'styled-components'

interface ComponentTitleProps {
  title: string
}

const ComponentTitle: React.FC<ComponentTitleProps> = ({ title }) => <Container>{title}</Container>

export default ComponentTitle

const Container = styled.div`
  font-size: 16px;
  font-weight: 500;
  color: #333;
  position: relative;
  padding-left: 12px;
  &::before {
    content: '';
    display: block;
    width: 4px;
    height: 16px;
    background: linear-gradient(180deg, #958dee 0%, #4238c9 100%);
    border-radius: 2px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
`
